import { GameColor, PRIMARY_COLORS, PrimaryColor, SECONDARY_COLORS, SecondaryColor } from "../types";

export const MIX_RECIPES: Record<SecondaryColor, readonly [PrimaryColor, PrimaryColor]> = {
    purple: ["red", "blue"],
    green: ["blue", "yellow"],
    orange: ["red", "yellow"],
};

export function isPrimary(color: GameColor): color is PrimaryColor {
    return (PRIMARY_COLORS as readonly GameColor[]).includes(color);
}

export function mixPrimaries(a: PrimaryColor, b: PrimaryColor): GameColor {
    if (a === b) return a;
    // MIX_RECIPES covers every pair of different primaries, so a match always exists
    return SECONDARY_COLORS.find((s) => MIX_RECIPES[s].includes(a) && MIX_RECIPES[s].includes(b))!;
}

/**
 * Spec §3: a double-tap resets to the pressed primary. Otherwise a press mixes
 * with the current primary, or switches straight to the pressed primary when a
 * secondary is active.
 */
export function nextColor(current: GameColor, pressed: PrimaryColor, isDoubleTap: boolean): GameColor {
    if (isDoubleTap || !isPrimary(current)) return pressed;
    return mixPrimaries(current, pressed);
}
